module.exports = __webpack_public_path__ + "img/12.d02f9300.png";